module.exports = __webpack_public_path__ + "static/media/6.52497335.JPG";